// extracted by mini-css-extract-plugin
module.exports = {"layout":"BodySubFeaturesMobile_layout_2EzH5","videoMobile":"BodySubFeaturesMobile_videoMobile_aJhsN"};